import axiosWrapper, { InterceptorOptions } from './axios-wrapper'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
)

export function apiGetFaults({
  makeModelIds,
  stationIds,
  start_at,
  end_at,
  station_alerts,
  plants,
  zones,
  teams,
  department,
  testZones,
  reason,
  vinStatus,
  includeRepairNotes,
}) {
  const body = { start_at, end_at }
  if (makeModelIds.length > 0) body.makeModelIds = makeModelIds.join()
  if (stationIds.length > 0) body.stationIds = stationIds.join()
  if (station_alerts && station_alerts.length > 0)
    body.station_alerts = station_alerts
  if (plants && plants.length > 0) body.plants = plants
  if (zones && zones.length > 0) body.zones = zones
  if (teams && teams.length > 0) body.teams = teams
  if (department) body.department = department
  if (testZones && testZones.length > 0) {
    body.hardware_location_ids = testZones
  }
  if (reason) body.reason = reason
  if (vinStatus) body.status = vinStatus
  if (includeRepairNotes) body.includeRepairNotes = true
  return api.post(`/faults`, body).then((resp) => resp.data)
}

export function apiGetFaultTypes() {
  return api.get('/faults/types').then((resp) => resp.data)
}

export function apiGetFaultByProblemLogId(problemLogId) {
  return api
    .get(`/faults/by-problem-log-id/${problemLogId}`)
    .then((resp) => resp.data)
}

export function ensureFaultRow({ makeModelId, key, type = 'other' }) {
  return api
    .post('/faults/ensure', { makeModelId, key, type })
    .then((resp) => resp.data)
}
